var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Facilities",
            "tabActive": "Meitex_Vietnam",
            "bg": "/images/sub/visual/sv-facilities.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first"
  }, [_c('div', {
    staticClass: "tit-wrap text-center"
  }, [_c('h3', {
    staticClass: "tit tit--lg"
  }, [_vm._v("Meitex_Vietnam")])]), _c('v-row', {
    staticClass: "row--small",
    attrs: {
      "align": "center",
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit tit--symbol",
    attrs: {
      "data-aos": "fade-right"
    }
  }, [_vm._v("Knitting&Dyeing Factory")])]), _c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "auto"
    }
  }, [_c('p', {
    staticClass: "page-text grey-a--text text-right"
  }, [_vm._v("Meitex_Vietnam")])])], 1), _c('v-divider', {
    staticClass: "border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40"
  }), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/vietnam4.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "src": "/images/sub/facilities/vietnam3.jpg"
    }
  })], 1)], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "height": "100%",
      "src": "/images/sub/facilities/vietnam2.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "height": "100%",
      "src": "/images/sub/facilities/vietnam1.jpg"
    }
  })], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('v-img', {
    staticClass: "ma-auto",
    attrs: {
      "height": "100%",
      "src": "/images/sub/facilities/vietnam0.jpg"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }